export default "__VITE_ASSET__CxrQvNMZ__"